/**
 * Countries a showcase project can be attributed to.
 *
 * The list is deliberately limited to the ones we ship a flag for, under
 * public/images/flags/<code>.svg, so every project that names a country can
 * always show one. To add a country: drop <code>.svg into that folder and add
 * a line here. Codes are ISO 3166-1 alpha-2, lowercase, which is also what
 * goes into showcase_project.country_code.
 */
export const COUNTRY_OPTIONS = [
  { code: 'ae', name: 'United Arab Emirates' },
  { code: 'au', name: 'Australia' },
  { code: 'ca', name: 'Canada' },
  { code: 'de', name: 'Germany' },
  { code: 'gb', name: 'United Kingdom' },
  { code: 'in', name: 'India' },
  { code: 'lv', name: 'Latvia' },
  { code: 'nl', name: 'Netherlands' },
  { code: 'pl', name: 'Poland' },
  { code: 'sg', name: 'Singapore' },
  { code: 'us', name: 'United States' },
]

const BY_CODE = new Map(COUNTRY_OPTIONS.map((c) => [c.code, c]))

/** Resolve a stored code to { code, name, flag }, or null if we cannot. */
export function getCountry(code) {
  const key = String(code || '').trim().toLowerCase()
  if (!key) return null
  const hit = BY_CODE.get(key)
  if (!hit) return null
  return { ...hit, flag: `/images/flags/${hit.code}.svg` }
}

export default COUNTRY_OPTIONS
